import React from "react";

import { ContentModuleBaseAttributes } from "utils/orm";
import { RichTextModule } from "components/RichTextModule";

export interface EmbedContent {
    providerName: string;
    url: string;
    height?: number;
    width?: number;
    code: string;
    type?: string;
    title?: string;
}

interface EmbedData {
    embed?: EmbedContent;
}

export interface EmbedBlock extends ContentModuleBaseAttributes {
    embed: EmbedData;
    richText?: string;
    template: string;
}

const stripWhiteSpace = (str: string) => str.replace(/\n/g, "");

const stripEnclosingDivs = (str: string) => {
    let newstr = stripWhiteSpace(str);
    [, newstr] = newstr.match(/(?:<div>)(.*)(?=<\/div>)/m);
    return newstr;
};

const getEmbedClassname = (providerName: string) => {
    const EmbedClassNameMap: { [key: string]: string } = {
        Facebook: "fb-embed-container",
        Twitter: "twitter-embed-container",
        YouTube: "ytplayer-embed-container",
        Instagram: "instagram-embed-container"
    };
    return Object.prototype.hasOwnProperty.call(EmbedClassNameMap, providerName) ? EmbedClassNameMap[providerName] : "other-embed-container";
};

const renderEmbed = (embed: EmbedContent, template: string) => {
    const {
        providerName = null,
        type = null,
        url = null,
        title = null,
        code
    } = embed;
    const isYoutube = type === "video" && providerName === "YouTube";


    const impressionTrackingProps = JSON.stringify({
        sp_impression_component: "insert",
        sp_impression_insert_type: "media",
        sp_impression_position: template === "article" ? "in_article" : null,
        sp_media_type: "video",
        sp_media_id: isYoutube ? url : null,
        sp_media_name: title,
        sp_media_provider_key: isYoutube ? url.split("=")[1] : null,
        sp_media_provider_name: providerName ?? null,
    });

    return (
        <div
            className={getEmbedClassname(providerName)}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: stripEnclosingDivs(code) }}
            data-tracking-event-type="impression"
            data-tracking-props={impressionTrackingProps}
        />
    );
};

export const EmbedModule: React.FC<EmbedBlock> = ({
    heading, embed, richText, template
}) => {
    const { embed: embedContent } = embed || {};

    if (!embedContent) {
        return null;
    }

    return (
        <div className="article-body__content-module__embed">
            {heading && <h1>{heading}</h1>}
            {renderEmbed(embedContent, template)}
            {richText && (
                <RichTextModule
                    className="article-body__content-module__embed__rich-text"
                    type="richTextBlock"
                    richText={richText}
                />
            )}
        </div>
    );
};
